import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import DriveRoutes from 'routes/drive.routes';
import './DrivesPage.css';
import { hasPermissionTo } from 'services/authorization.service';

import { useTranslation } from 'react-i18next';

export interface DrivesPageProps { }

const DrivesPage: React.FC<DrivesPageProps> = () => {
	const { t } = useTranslation();
	return (
		<section id='drives'>
			<Row className='align-items-center mb-3'>
				<Col>
					<h3 className='font-weight-bold'>{t('drives.header')}</h3>
				</Col>
				{hasPermissionTo('CREATE_DRIVE') && (
					<Col className='text-right'>
						<Link to='/r/drives/nuevo'>
							<Button variant='danger' className='text-capitalize'>
								<FontAwesomeIcon icon={faPlus} className='mr-3' size='lg' />
								{t('drives.new')}
							</Button>
						</Link>
					</Col>
				)}
			</Row>
			<Card>
				<Card.Header className='bg-dark-orange'></Card.Header>
				<Card.Body>
					<DriveRoutes />
				</Card.Body>
			</Card>
		</section>
	);
};

export default DrivesPage;
